import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms-customer",
  "use": "icon-cms-customer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-cms-customer\"><path d=\"M85.333333 938.666667a341.333333 341.333333 0 0 1 682.666667 0H85.333333z m341.333334-384c-141.44 0-256-114.56-256-256s114.56-256 256-256 256 114.56 256 256-114.56 256-256 256z m426.666666 170.666666h170.666667v85.333334h-170.666667v-85.333334z m-128-213.333333h298.666667v85.333333h-298.666667v-85.333333z m85.333334-213.333333h213.333333v85.333333h-213.333333V298.666667z\" p-id=\"1979\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms-customer.svg
// module id = hVpq
// module chunks = 20